import { render } from "./DocumentFileUploadModal.vue?vue&type=template&id=b75054e6"
import script from "./DocumentFileUploadModal.vue?vue&type=script&lang=js"
export * from "./DocumentFileUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__